import { render } from "./TokenChargePage.vue?vue&type=template&id=8b3abce8&scoped=true"
import script from "./TokenChargePage.vue?vue&type=script&lang=js"
export * from "./TokenChargePage.vue?vue&type=script&lang=js"

import "./TokenChargePage.vue?vue&type=style&index=0&id=8b3abce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3abce8"]])

export default __exports__